import styled from '@emotion/styled'
import { colors, font, spacing } from '@mobi/component-library/Theme/Common'
import { greaterThan } from '@mobi/component-library/Utils/media'

const largeScreen = greaterThan('px425')

export const MfaVerificationCodePageContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  padding: `${spacing.bigx1} ${spacing.md}`,
  fontFamily: font.family.primary,

  [largeScreen]: {
    margin: `20px ${spacing.bigx3}`,
  },
})

export const MfaCodePageText = styled.p({
  textAlign: 'left',
  margin: 0,
  padding: 0,
})

export const MfaCodePageHeader = styled.h1({
  '&&': {
    fontFamily: font.family.primary,
    ...font.size.xl4,
    fontWeight: font.weight.semibold,
    color: colors.black,
    alignSelf: 'left',
    margin: 0,
    padding: 0,
    textTransform: 'capitalize',
  },
})
